<template>
  <div class="complaint_container">
    <div class="complaint_head_block">
        <h3 class="head_block_title" v-if="isPC">举报投诉</h3>
        <span class="head_block_text" @click="checkRecord">{{ $en('历史记录') }}</span>
    </div>
    <div class="complaint_content_block">
        <!-- <div class="content_row_block">
            <span style="color: red;">*</span>
            <span class="row_title_text">被举报人工号</span>
            <div class="row_right_block">
                <el-input type="text" v-model="form.byComplaintPersonId" placeholder="请填写被举报人工号"></el-input>
            </div>
        </div>
        <div class="content_row_block">
            <span style="color: red;">*</span>
            <span class="row_title_text">被举报人姓名</span>
            <div class="row_right_block">
                <el-input type="text" v-model="form.byComplaintPersonName" placeholder="请填写被举报人姓名"></el-input>
            </div>
        </div>
        <div class="row_block_other">
            <span style="color: red;">*</span>
            <span class="row_title_text">被举报人单位</span>
        </div>
        <div class="content_row_block">
            <div class="row_right_block">
                <el-input type="text" v-model="form.byComplaintDept" placeholder="请填写被举报人单位"></el-input>
            </div>
        </div> -->
				<PersonSelect :label="$en('被举报人')" v-model="form.byComplaintPersonId" :personName.sync="form.byComplaintPersonName" @select="selectByComplaintPerson" class="person_select_row"/>
        <div class="row_block_other">
            <span style="color: red;">*</span>
            <span class="row_title_text">{{ $en('被举报人单位') }}</span>
        </div>
        <div class="content_row_block" style="height:60px;">
            <div style="flex: 1;">
                <el-input type="textarea" readonly v-model="form.byComplaintDept" :placeholder="$en('选择被举报人后自动带出')" rows="2"></el-input>
            </div>
        </div>
				<div class="row_block_other">
            <span style="color: red;">*</span>
            <span class="row_title_text">{{ $en('举报内容') }}</span>
        </div>
        <div class="row_block_textarea">
            <el-input type="textarea" :placeholder="$en('请填写举报内容')" v-model="form.complaintContent" maxlength="5000" :autosize="{minRows:4}" show-word-limit></el-input>
        </div>

        <div class="row_upload_block">
            <FieldUpload :fileIds="imgList" :label="$en('上传图片')" type="IMG" @fileChange="imgList=$event"/>
            <FieldUpload :fileIds="fileList" :label="$en('上传文件')" @fileChange="fileList=$event"/>
        </div>

        <div class="row_upload_block">
            <div class="info_row_block">
                <span style="color: red;">*</span>
                <span class="row_title_text">{{ $en('您的信息') }}</span>
                <div class="info_row_head">
                    <van-radio-group v-model="form.info" class="info_radio_group" @change="changeIsFill">
                        <van-radio name="1">{{ $en('填写') }}</van-radio>
                        <van-radio name="2">{{ $en('不填写') }}</van-radio>
                    </van-radio-group>
                </div>
            </div>
            
            <div class="info_show_block" v-if="form.info == '1'">
							<PersonSelect :label="$en('姓名')" v-model="form.complaintPersonId" :personName.sync="form.name" @select="selectPerson" class="person_select_row" :labelWidth="40"/>
							<div class="content_row_block" style="height:60px;">
									<span class="row_title_text">{{ $en('单位') }}</span>
									<div style="flex:1;">
											<el-input class="border_0" type="textarea" v-model="form.dept" :placeholder="$en('请填写您的单位')" readonly rows="2"></el-input>
									</div>
							</div>
							<div class="content_row_block">
									<span class="row_title_text">{{ $en('手机') }}</span>
									<div class="row_right_block">
											<el-input type="number" v-model="form.phone" :placeholder="$en('请填写您的手机')"></el-input>
									</div>
							</div>
							<div class="content_row_block">
									<span class="row_title_text">{{ $en('邮箱') }}</span>
									<div class="row_right_block">
											<el-input type="text" v-model="form.email" :placeholder="$en('请填写您的邮箱')"></el-input>
									</div>
							</div>
								<!-- <div class="content_row_block">
                    <span class="row_title_text">姓名</span>
                    <div class="row_right_block">
                        <el-input type="text" v-model="form.name" placeholder="请填写您的姓名"></el-input>
                    </div>
                </div>
                <div class="content_row_block">
                    <span class="row_title_text">单位</span>
                    <div class="row_right_block">
                        <el-input type="text" v-model="form.dept" placeholder="请填写您的单位"></el-input>
                    </div>
                </div>
                <div class="content_row_block">
                    <span class="row_title_text">手机</span>
                    <div class="row_right_block">
                        <el-input type="number" v-model="form.phone" placeholder="请填写您的手机"></el-input>
                    </div>
                </div>
                <div class="content_row_block">
                    <span class="row_title_text">邮箱</span>
                    <div class="row_right_block">
                        <el-input type="text" v-model="form.email" placeholder="请填写您的邮箱"></el-input>
                    </div>
                </div> -->
            </div>

            <div class="info_show_block" v-if="form.info == '2'">
                <span class="info_no_fill">{{ $en('实名举报线索将优先进行调查，我们对举报人信息严格保密。不提供联系方式，我们将无法与您取得联系，了解更多信息，同时您也无法了解调查的进展与结果。') }}</span>
            </div>
        </div>

        <div class="submit_btn" @click="submitEvent">{{ $en('提交') }}</div>
    </div>
  </div>
</template>

<script>
import PersonSelect from '@/plugins/PersonSelect'
import { Toast } from 'vant-green'
import { en } from '@/locale/i18n/i18n'
export default {
		name: 'Complaint',
		components:{
			PersonSelect
		},
    data() {
        return {
            form:{
                byComplaintPersonId:'',
                byComplaintPersonName:'',
                byComplaintDept:'',
                complaintContent:'',
                name:'',
                dept:'',
                phone:'',
                email:'',
                files:'',
                imgs:'',
                info:'1',
								personNo:'',
								deptId:''
            },

            imgList:[],
            fileList:[],

            fillStatus:false,
			isPC: window.innerWidth >= 769
        }
    },

    created(){
				document.title = en('举报投诉')
				this.initComplaintPerson()
    },

    methods: {
			async initComplaintPerson(){
				let person = JSON.parse(localStorage.getItem('userInfo'))
				// this.$set(this.form,'complaintPersonId',person.persionId)
				this.form.complaintPersonId = person.persionId
			},
			async selectPerson(person,isInit){
				let orgInfo = await this.getOrgInfo(person.ORG_GUID)

				this.form.name = person.OGU_NAME
				this.form.personNo = person.OGU_GUID
				this.form.deptId = person.ORG_GUID
				this.form.dept = orgInfo.orgFullPathName
				this.form.email = person.OGU_EMAIL
				this.form.phone = person.U_PHONE
			},
			async selectByComplaintPerson(person){
				let orgInfo = await this.getOrgInfo(person.ORG_GUID)
				this.form.byComplaintDeptId = person.ORG_GUID
				this.form.byComplaintDept = orgInfo.orgFullPathName
			},
        //选择是否填写
        changeIsFill(val){
            if(val == '1'){
                this.fillStatus = false
            }else{
                this.fillStatus = true
            }
            
        },

        //查看历史记录
        checkRecord(){
            this.$router.push({
                name: "table"
            });
        },

        //提交
        submitEvent(){
            if(this.form.byComplaintPersonId == ''){
                this.$message.error(en('请选择被举报人'))
            }else if(this.form.complaintContent == ''){
                this.$message.error(en('请填写举报内容'))
            }else{
                if(this.form.info == '1'){
                    if(this.form.name == ''){
                        this.$message.error(en('请填写您的姓名'))
                    }else if(this.form.dept == ''){
                        this.$message.error(en('请填写您的单位'))
                    }else if(this.form.phone == '' && this.form.email == ''){
                        this.$message.error(en('请填写您的手机号或者邮箱，二选一'))
                    }else{
                        this.setSaveInfo()
                    }
                }else{
										// this.form.name = ''
										// this.form.dept = ''
										// this.form.phone = ''
										// this.form.email = ''
										// this.form.personNo = ''
										// this.form.deptId = ''
                    this.setSaveInfo()
                }
            }
        },

        //提交信息保存
        setSaveInfo(){
            if(this.fileList && this.fileList.length>0){
                this.form.files = this.fileList.join(',')
            }else{
                this.form.files = undefined
            }
            if(this.imgList && this.imgList.length>0){
                this.form.imgs = this.imgList.join(',')
            }else{
                this.form.imgs = undefined
            }
            this.Dialog.confirm({
                title:en('警告'),
                message:en('请确认是否提交数据，提交后数据将不能修改。')
            }).then(()=>{
								Toast.loading({
									message:en('加载中。。。'),
									forbidClick:true,
									overlay:true,
									duration:30000
								})
								let form = JSON.parse(JSON.stringify(this.form))
								if(form.info!='1'){
									form.name = ''
									form.dept = ''
									form.phone = ''
									form.email = ''
									form.personNo = ''
									form.deptId = ''
								}
                this.$http.post('/api/ts/v0.1/complaint/save',form)
                .then(res=>{
                    if (res.data >= 1) {
                        this.fileList = []
                        this.imgList = []
                        this.form = {
														...this.form,
                            byComplaintPersonId:'',
                            byComplaintPersonName:'',
                            byComplaintDept:'',
                            complaintContent:'',
                            files:'',
                            imgs:'',
														info:'1'
                        }
                        // this.$message.success('操作成功')
                        this.Dialog.alert({
                            title:en('提醒'),
                            message:en('操作成功')
												})
												this.initComplaintPerson()
                        // this.form = {}
                    } else if(res.data) {
                        // this.$message.error('操作失败')
                        this.Dialog.alert({
                            title:en('警告'),
                            message:en('操作失败')
                        })
                    }else{
                        // this.$message.error('您已经提交过了') 
                        this.Dialog.alert({
                            title:en('警告'),
                            message:en('您已经提交过了')
                        })
                    }
										Toast.clear()
                })
                .catch((err)=>{
										Toast.clear()
                    // this.$message.error('操作失败')
                    this.Dialog.alert({
                        title:en('警告'),
                        message:en('操作失败')
                    })
                })
            // }).catch(()=>{

            })
				},
				
			async getOrgInfo(orgGuid){
				if(!orgGuid){
					return {}
				}
				let orgInfo = await this.$http.get('/api/orgPerson/v0.1/org/getOrgByGuid',{
					params:{
						orgGuid:orgGuid
					}
				})
				return orgInfo.data.data||{}
			},
			async getUserInfo(oguGuid){
				if(!oguGuid){
					return {}
				}
				let userList = await this.$http.get('/api/orgPerson/v0.1/orgPerson/getUserList',{
					params:{
						oguGuids:oguGuid
					}
				})
				if(userList&&userList.data&&userList.data.list&&userList.data.list.length>0){
					return userList.data.list[0]
				}
				return {}
			},
    }
}
</script>

<style scoped lang='less'>
    .complaint_container{
        width: 100%;
        position: fixed;
        left: 0;
        top: 0;
        bottom: 0;
        background-color: #f2f2f2;
    }
    .complaint_head_block{
        width: 100%;
        height: 40px;
        background-color: white;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
        position: absolute;
        left: 0;
        top: 0;
    }
    .head_block_text{
        display: block;
        font-size: 16px;
        color: #44baff;
        margin-right: 10px;
    }
    .complaint_content_block{
        width: 100%;
        position: absolute;
        left: 0;
        top: 50px;
        bottom: 0;
        background-color: white;
        overflow-y: scroll;
        padding: 20px;
        box-sizing: border-box;
    }
    .content_row_block{
        width: 100%;
        height: 40px;
        border-bottom: 1px solid #f2f2f2;
        display: flex;
        flex-direction: row;
        align-items: center;
    }
    .row_title_text{
        display: block;
        font-size: 16px;
        color: #333;
        margin-right: 10px;
    }
    .row_right_block{
        flex: 1;
        height: 40px;
    }

    /deep/ .el-input__inner{
        border: none;
    }
    .row_block_other{
        width: 100%;
        height: 30px;
        display: flex;
        flex-direction: row;
        align-items: center;
    }
    .row_block_textarea{
        width: 100%;
        height: auto;
        border-bottom: 1px solid #f2f2f2;
    }
    .row_upload_block{
        width: 100%;
        height: auto;
        margin-top: 20px;
    }
    .info_row_block{
        width: 100%;
        height: 40px;
        border-bottom: 1px solid #f2f2f2;
        display: flex;
        flex-direction: row;
        align-items: center;
    }
    .info_row_head{
        flex: 1;
        height: 40px;
        margin-left: 30px;
        display: flex;
        flex-direction: row;
        align-items: center;
    }
    .info_radio_group{
        display: flex;
        flex-direction: row;
        align-items: center;
        /deep/ .van-radio{
            margin-right: 30px;
        }
    }
    .info_show_block{
        width: 100%;
        height: auto;
    }
    .submit_btn{
        width: 120px;
        height: 40px;
        background-color: #0169ff;
        border-radius: 4px;
        margin-left: auto;
        margin-right: auto;
        margin-top: 60px;
        margin-bottom: 50px;
        font-size: 16px;
        color: white;
        line-height: 40px;
        text-align: center;
    }
    .info_no_fill{
        display: block;
        font-size: 16px;
        color: #666;
        text-align: justify;
        line-height: 24px;
        margin-top: 20px;
    }
    .person_select_row{
        margin: 0px -10px;
        border-bottom: 1px solid #f2f2f2;
    }

    /* PC端响应式样式 */
    @media (min-width: 769px) {
        .complaint_container{
            min-height: 100vh;
            background-color: #fff;
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 40px 20px;
            box-sizing: border-box;
        }
        .complaint_head_block{
            width: 100%;
            padding: 6px 20px;
            background: #fff;
            position: relative;
            margin-bottom: 10px;
            border: none;
            position: relative;
            height: auto;
            justify-content: space-between;
            box-sizing: border-box;
            height: auto;
            &::before {
                content: '';
                position: absolute;
                left: 0;
                top: 4px;
                bottom: 4px;
                width: 4px;
                background-color: #027cfb;
                border-radius: 0 6px 6px 0;
            }
        }
        .head_block_title{
            font-size: 22px;
            color: #333;
            margin: 0;
            font-weight: 600;
        }
        .head_block_text{
            font-size: 20px;
            color: #0169ff;
            cursor: pointer;
            &:hover{
                text-decoration: underline;
            }
        }
        .complaint_content_block{
            width: 100%;
            height: 100%;
            position: initial;
            background-color: #fff;
            border-radius: 0 0 8px 8px;
            padding: 30px 120px;
            overflow-y: auto;
            font-size: 18px!important;
            border-top: 1px solid #999;
            .row_title_text,.van-cell{
                font-size: 18px;
            }
            /deep/ .van-cell{
                padding: 10px 16px 10px 7px;
            }
            /deep/.van-cell--required::before{
                left: 0px;
            }
            /deep/ .van-cell__title{
                font-size: 18px;
            }
        }
        .content_row_block{
            height: auto;
            min-height: 40px;
            padding: 8px 0;
            border-bottom: none;
        }
        /deep/ .el-input__inner{
            border: 1px solid #dcdfe6;
            border-radius: 4px;
        }
        .row_block_other{
            height: auto;
            padding-top: 16px;
            margin-bottom: 4px;
        }
        .row_block_textarea{
            border-bottom: none;
        }
        .info_row_block{
            height: auto;
            min-height: 40px;
            padding: 8px 0;
            border-bottom: none;
        }
        .info_row_head{
            margin-left: 10px;
        }
        .info_radio_group{
            /deep/ .van-radio{
                margin-right: 20px;
            }
        }
        .submit_btn{
            width: 180px;
            height: 44px;
            line-height: 44px;
            font-size: 18px;
            border-radius: 4px;
            cursor: pointer;
            transition: background-color 0.2s;
            margin-top: 40px;
            &:hover{
                background-color: #0055cc;
            }
        }
        .info_no_fill{
            background-color: #fdf6ec;
            padding: 14px 18px;
            border-radius: 4px;
            border-left: 3px solid #e6a23c;
            font-size: 18px;
            color: #666;
            margin-top: 10px;
            line-height: 22px;
        }
        .person_select_row{
            margin: 0;
            border-bottom: none;
            padding: 8px 0;
        }
        .row_upload_block{
            margin-top: 12px;
        }
    }
</style>

<style>
	.border_0 .el-textarea__inner{
		border:0px !important;
	}
</style>